module.exports = __webpack_public_path__ + "static/media/mouzikti.3cc9f598.jpg";